import { ProjectAddElementButton } from '../../../components/exo/project/ProjectAddElementButton';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewLeadStatus } from './NewLeadStatus';
import ExoDialog from '../../../components/exo/ExoDialog';
import { Box, IconButton, Typography } from '@mui/material';
import { Status } from '../../../components/special/Status';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { API_DELETE, DBRequest, useConfig } from '../../../api/api';

export const StatusEditor = ({
  open,
  statuses,
  onCreate,
  onUpdate,
  onClose,
  onDelete,
}) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [openNewStatus, setOpenNewStatus] = useState(false);
  const [edit, setEdit] = useState(null);

  function handleEditStatus(status) {
    setEdit(status);
    setOpenNewStatus(true);
  }

  function handleNewStatus() {
    setEdit(null);
    setOpenNewStatus(true);
  }

  function handleFormResponse(data) {
    onCreate(data);
    setOpenNewStatus(false);
    setEdit(false);
  }

  function handleDelete(status) {
    DBRequest({
      config,
      path: `lead-statuses/${status.id}`,
      method: API_DELETE,
      onResponse: () => onDelete(status),
    });
  }

  return (
    <ExoDialog open={open} onClose={onClose} limitWidth>
      <Typography variant="h3" textAlign="center">
        {t('Edit Lead Statuses')}
      </Typography>
      <Box className="flex flex-col gap-2 pt-2 pb-4">
        {statuses?.map((status, index) => (
          <Box
            className="flex items-center gap-2"
            key={'Status' + status.label + index}
          >
            <IconButton onClick={() => handleDelete(status)}>
              <DeleteIcon color="error" />
            </IconButton>
            <Status
              text={status.label}
              variant={status.variant}
              statusColor={status.color}
            />
            <IconButton size="small" onClick={() => handleEditStatus(status)}>
              <EditIcon />
            </IconButton>
          </Box>
        ))}
      </Box>
      <ProjectAddElementButton
        onClick={handleNewStatus}
        label={t('New Status')}
        size="small"
        sx={{ padding: '0px' }}
      />
      <NewLeadStatus
        open={openNewStatus}
        onClose={() => setOpenNewStatus(false)}
        onUpdate={handleFormResponse}
        onCreate={handleFormResponse}
        startData={edit}
      />
    </ExoDialog>
  );
};
